// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loading Fallback Styles */
.hdv2-loading-root {
  min-height: calc(100vh - 72px);
  background: #f5f5f5; /* Plain light gray background */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.hdv2-loading-container {
  text-align: center;
  padding: 3rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  animation: hdv2-fadeInUp 0.6s ease-out;
  z-index: 1;
  min-width: 320px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

@keyframes hdv2-fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animated spinner */
.hdv2-loading-spinner {
  width: 80px;
  height: 80px;
  margin: 0 auto 2rem;
  position: relative;
}

.hdv2-loading-spinner::before,
.hdv2-loading-spinner::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  animation: hdv2-pulse 2s ease-in-out infinite;
}

.hdv2-loading-spinner::before {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  opacity: 0.3;
  animation-delay: -0.5s;
}

.hdv2-loading-spinner::after {
  width: 60%;
  height: 60%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  top: 20%;
  left: 20%;
  animation-delay: 0s;
}

@keyframes hdv2-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
}

/* Loading content */
.hdv2-loading-content {
  margin-top: 1rem;
}

.hdv2-loading-title {
  font-size: 1.8rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 0.75rem;
  animation: hdv2-gradientShift 3s ease infinite;
}

@keyframes hdv2-gradientShift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.hdv2-loading-message {
  color: #64748b;
  font-size: 1rem;
  margin-bottom: 2rem;
}

/* Progress bar */
.hdv2-loading-progress {
  width: 100%;
  height: 4px;
  background: #e2e8f0;
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.hdv2-loading-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
  animation: hdv2-loading 1.5s ease-in-out infinite;
  width: 30%;
}

@keyframes hdv2-loading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .hdv2-loading-container {
    margin: 1rem;
    padding: 2rem;
    min-width: auto;
    width: 90%;
  }

  .hdv2-loading-title {
    font-size: 1.4rem;
  }

  .hdv2-loading-spinner {
    width: 60px;
    height: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Dashbaord/Dashboard.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,mBAAmB,EAAE,gCAAgC;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,sCAAsC;EACtC,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6DAA6D;EAC7D,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;EAClB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Loading Fallback Styles */\n.hdv2-loading-root {\n  min-height: calc(100vh - 72px);\n  background: #f5f5f5; /* Plain light gray background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.hdv2-loading-container {\n  text-align: center;\n  padding: 3rem;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 2rem;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);\n  animation: hdv2-fadeInUp 0.6s ease-out;\n  z-index: 1;\n  min-width: 320px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n@keyframes hdv2-fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Animated spinner */\n.hdv2-loading-spinner {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 2rem;\n  position: relative;\n}\n\n.hdv2-loading-spinner::before,\n.hdv2-loading-spinner::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  animation: hdv2-pulse 2s ease-in-out infinite;\n}\n\n.hdv2-loading-spinner::before {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  opacity: 0.3;\n  animation-delay: -0.5s;\n}\n\n.hdv2-loading-spinner::after {\n  width: 60%;\n  height: 60%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  top: 20%;\n  left: 20%;\n  animation-delay: 0s;\n}\n\n@keyframes hdv2-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.7;\n  }\n}\n\n/* Loading content */\n.hdv2-loading-content {\n  margin-top: 1rem;\n}\n\n.hdv2-loading-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  margin-bottom: 0.75rem;\n  animation: hdv2-gradientShift 3s ease infinite;\n}\n\n@keyframes hdv2-gradientShift {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.hdv2-loading-message {\n  color: #64748b;\n  font-size: 1rem;\n  margin-bottom: 2rem;\n}\n\n/* Progress bar */\n.hdv2-loading-progress {\n  width: 100%;\n  height: 4px;\n  background: #e2e8f0;\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.hdv2-loading-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  border-radius: 2px;\n  animation: hdv2-loading 1.5s ease-in-out infinite;\n  width: 30%;\n}\n\n@keyframes hdv2-loading {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(400%);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .hdv2-loading-container {\n    margin: 1rem;\n    padding: 2rem;\n    min-width: auto;\n    width: 90%;\n  }\n\n  .hdv2-loading-title {\n    font-size: 1.4rem;\n  }\n\n  .hdv2-loading-spinner {\n    width: 60px;\n    height: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
